import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-relative tw-flex tw-h-[calc(100%-5.5rem)] tw-flex-col" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-justify-between tw-border-b tw-px-2 tw-py-2" }
const _hoisted_3 = {
  key: 0,
  class: "tw-text-md"
}
const _hoisted_4 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_5 = {
  key: 0,
  class: "tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center"
}
const _hoisted_6 = {
  key: 1,
  class: "tw-m-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-red-500" }, "Error loading results", -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioSearchInput = _resolveComponent("StudioSearchInput")!
  const _component_StudioSpinner = _resolveComponent("StudioSpinner")!
  const _component_InfiniteScrollContainer = _resolveComponent("InfiniteScrollContainer")!
  const _component_StudioDialog = _resolveComponent("StudioDialog")!

  return (_openBlock(), _createBlock(_component_StudioDialog, {
    title: _ctx.title,
    size: "large",
    primaryActionTitle: _ctx.primaryActionTitle,
    secondaryActionTitle: "Cancel",
    primaryActionDisabled: _ctx.isUploadingNewFile || _ctx.isPrimaryActionDisabled,
    onPrimaryAction: _ctx.handleSaveClicked,
    onSecondaryAction: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.resultsCountText), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_StudioSearchInput, {
              searchTerm: _ctx.searchTerm,
              onOnSearch: _ctx.handleOnSearch
            }, null, 8, ["searchTerm", "onOnSearch"]),
            _renderSlot(_ctx.$slots, "upload-button", {
              success: _ctx.handleUploadSuccess,
              init: () => (_ctx.isUploadingNewFile = true),
              failure: () => (_ctx.isUploadingNewFile = false),
              close: () => (_ctx.isUploadingNewFile = false)
            })
          ])
        ]),
        _createVNode(_component_InfiniteScrollContainer, {
          class: "tw-flex tw-flex-1 tw-flex-col tw-overflow-scroll",
          pause: _ctx.loadingMore,
          onScrollBottom: _ctx.handleScrollBottom
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assets, (asset) => {
              return (_openBlock(), _createElementBlock("div", {
                key: asset.id,
                class: "tw-border-b"
              }, [
                _renderSlot(_ctx.$slots, "assets-list-item", {
                  asset: asset,
                  isSelected: _ctx.isAssetSelected(asset),
                  handleSelectAsset: _ctx.handleSelectAsset,
                  handleDeleteSuccess: _ctx.handleDeleteSuccess,
                  handleRenameSuccess: _ctx.handleRenameSuccess
                })
              ]))
            }), 128)),
            (_ctx.loading || _ctx.isUploadingNewFile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_StudioSpinner, {
                    coverContainer: false,
                    size: "small",
                    overlay: _ctx.isUploadingNewFile,
                    class: "tw-m-auto"
                  }, null, 8, ["overlay"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["pause", "onScrollBottom"])
      ])
    ]),
    _: 3
  }, 8, ["title", "primaryActionTitle", "primaryActionDisabled", "onPrimaryAction"]))
}